import store from "app/store/store";
import { WidgetData } from "app/types/eventType";
import {
  geniusGametrackerSports,
  geniusScoreboardSports,
} from "app/utils/const";

export class WidgetHelper {
  static getGeniusIFrameURL(
    sportTypeName: string,
    fixtureId: string,
    standAloneSection?: string
  ): string {
    // Example url: https://gsm-widgets.betstream.betgenius.com/multisportscoreboard?productName=3et-dark&fixtureId=10935782
    const darkModeStatus = store.getState().sessionModel.darkMode;
    let lightDarkMode = darkModeStatus ? "dark" : "light";
    const product = this.getProduct(sportTypeName);
    if (!product) {
      return "";
    }
    const productName = `3et-${lightDarkMode}`;
    // If a widget name is passed as a param, will show only one part of the widget,
    // eg &widget=scoreboard only shows the scoreboard, otherwise the full widget is shown
    // eg https://gsm-widgets.betstream.betgenius.com/multisportgametracker/?fixtureId=10316908&productName=3et-light&widget=scoreboard
    const widget = standAloneSection ? `&widget=${standAloneSection}` : "";
    return `https://gsm-widgets.betstream.betgenius.com/${product}/?fixtureId=${fixtureId}&productName=${productName}${widget}`;
  }
  static getProduct(sportTypeName: string): string {
    if (geniusGametrackerSports.includes(sportTypeName)) {
      return "multisportgametracker";
    } else if (geniusScoreboardSports.includes(sportTypeName)) {
      return "multisportscoreboard";
    } else {
      return "";
    }
  }

  static getSourceFixtureId(widgets: WidgetData): string | null {
    const provider = widgets.widgetProvider;
    if (provider in widgets) {
      return widgets[provider]?.sourceFixtureId || null;
    } else {
      // Handle cases where the provider doesn't match any in the widget
      console.error(`Provider '${provider}' not found in widget data.`);
      return "";
    }
  }
}
